<div class="bp-modal mod-lg wrapper">
  <bp-modal-header
    [title]="'send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name]"
    class="font-semibold">
    <a (click)="onBackButtonClick()" (keydown.enter)="onBackButtonClick()" [tabIndex]="0" left>
      {{ "back" | translate }}
    </a>
    <a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" [tabIndex]="0" right>
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    @if (amountData$ | async; as data) {
      <div class="bp-modal-body-section">
        @if (data.price) {
          <div class="bp-modal-description">
            <div class="description-title">
              {{ "choose_an_amount" | translate }}
            </div>
            <div class="tiles">
              <tradable-amount-tile
                class="amounts"
                (click)="setSendMaxAmount(data.price, data.cryptoPrecision, data.selectedCurrency)"
                [conversion]="getTradableAmountTitleConversion(data.price, data.cryptoPrecision)"
                [all]="true"
                [fiat]="fiat"
                [removePrecision]="data.cryptoPrecision === 0"
                [multichainTradable]="selectedCryptocoin"
                (keydown.enter)="setSendMaxAmount(data.price, data.cryptoPrecision, data.selectedCurrency)">
              </tradable-amount-tile>
            </div>
            <div class="amountInput">
              <bp-input
                iconLeading="true"
                class="mod-input-line"
                [iconUrl]="data.selectedCurrency === 'fiat' ? fiat?.getLogo() : this.selectedCryptocoin.logo"
                [iconUrlAltText]="'logo_alt_text' | translate"
                min="0"
                (onKeyEnter)="gotoSummary(data.price, data.precision)"
                [(value)]="inputAmount"
                [precision]="data.precision"
                required
                [type]="selectedCryptocoin.symbol === 'neo' ? 'zeroPrecision' : data.selectedCurrency"
                autofocus
						(valueChange)="
							amountChange(
								$event,
								data.price,
								data.precision,
								data.selectedCurrency,
								data.cryptoPrecision
							)
						"
                placeholder="0.00"
                [formGroupClass]="false">
                @if (data.precision === 0) {
                  <a right class="color-text">
                    <span
								[ngClass]="{
									'text-highlight font-size-17': data.selectedCurrency === 'cryptocoin'
								}">
                      {{ selectedCryptocoin.symbol | uppercase }}
                    </span>
                  </a>
                }
                @if (data.precision !== 0) {
                  <a
                    right
                    (click)="changeCurrency(data.price, data.precision, data.selectedCurrency)"
                    class="hover-pointer color-text"
                    href="javascript:">
                    <span
								[ngClass]="{
									'text-transparent font-size-17': data.selectedCurrency !== 'cryptocoin',
									'text-highlight font-size-17': data.selectedCurrency === 'cryptocoin'
								}">
                      {{ selectedCryptocoin.symbol | uppercase }}
                    </span>
                    <span>
                      &nbsp;/&nbsp;
                      <span
									[ngClass]="{
										'text-transparent font-size-17': data.selectedCurrency !== 'fiat',
										'text-highlight font-size-17': data.selectedCurrency !== 'cryptocoin'
									}">
                        {{ fiat?.getSymbol() }}
                      </span>
                    </span>
                  </a>
                }
              </bp-input>
            </div>
            <div class="details detail-with-fee">
              <div class="left-details">
                <div class="minimum">
                  {{ "minimum" | translate }}:
                  {{ (+data.price.getMinAmountExternal().tradableAmount()).toString() }}
                  {{ selectedCryptocoin.symbol | uppercase }} &asymp;
                  {{ (+data.price.getMinAmountExternal().fiatAmount()).toFixed(2) }}
                  {{ fiat?.getSymbolCharacter() }}
                </div>
                @if (data.balanceStatus) {
                  <div class="operational-balance">
                    @if (+data.balanceStatus.balance > +data.balanceStatus.operational_balance) {
                      <div>
                        {{
                        "available_multichain_balance"
                        | translate
                        : [
                        data.balanceStatus.operational_balance +
                        " " +
                        selectedCryptocoin?.symbol | uppercase
                        ]
                        }}
                        <span
                          [bp-tooltip]="'withdraw_operational_disclaimer' | translate"
                          class="no-ul"
                          position="top">
                          <i class="bpi__icon-info"></i>
                        </span>
                      </div>
                    }
                  </div>
                }
                <div class="fee">
                  {{ "fee" | translate }}
                  <a [href]="clickedFeeTooltip()" [target]="'_blank'">
                    <span
                      [bp-tooltip]="'send_modal_amount_tooltip' | translate"
                      class="no-ul"
                      position="top">
                      <i class="bpi__icon-info"></i>
                    </span>
                  </a>
                  {{ fee?.fee }} {{ selectedCryptocoin?.symbol | uppercase }} &asymp;
                  {{
                  +fee?.fiat_fee
                  | euro_to_user_fiat
                  | fiat_precision_symbol
                  : {
                  id: fiat.getId(),
                  currencies: [fiat],
                  customPrecision: 2,
                  symbol: true,
                  valueFirst: true
                }
                }}
              </div>
            </div>
            <div class="right-details">
              1 {{ selectedCryptocoin.symbol | uppercase }} &asymp;
              {{ (+data.price?.getPrice()?.getFiat()).toFixed(2) }} {{ fiat.getSymbolCharacter() }}
            </div>
          </div>
          <div class="total details">
            <div class="left-details">
              <div>
                <div class="total-title first-row">
                  {{ "amount_total" | translate }}
                </div>
                <div class="incl-fee">
                  {{ "inkl_fees_translation" | translate }}
                </div>
              </div>
            </div>
            <div class="right-details">
              <div class="total-amount first-row">
                {{ totalAmountInCrypto }} {{ selectedCryptocoin?.symbol | uppercase }}
              </div>
              <div class="fees-breakdown">
                &asymp; {{ amountWithoutFeesInFiat }} {{ fiat?.getSymbolCharacter() }}
                {{ "plus" | translate }}
                {{
                +fee.fiat_fee
                | euro_to_user_fiat
                | fiat_precision_symbol
                : {
                id: fiat.getId(),
                currencies: [fiat],
                customPrecision: 2,
                symbol: true,
                valueFirst: true
              }
              }}
              {{ "fees" | translate }}
            </div>
          </div>
        </div>
        <button
          (click)="gotoSummary(data.price, data.precision, data.cryptoPrecision)"
          class="btn btn-primary btn-lg mod-button-width button-next"
          type="button">
          {{ "Weiter" | translate }}
        </button>
      </div>
    }
  </div>
}
</div>
</div>
